<template>
  <b-row>
    <b-col cols="12">
      <b-row>
        <b-col
          xl="12"
          lg="12"
          md="12"
          sm="12"
        >
          <b-alert
            show
            variant="primary"
          >
            <div class="alert-body">
              <feather-icon
                class="mr-25"
                icon="PhoneIcon"
              />
              <span class="ml-25">Contacto</span>
            </div>
          </b-alert>
        </b-col>
      </b-row>
    </b-col>
    <b-col v-if="contacto">
      <div class="mx-1 mb-0">
        <h5 class="text-capitalize mb-75">
          Correo electronico:
        </h5>
        <b-card-text>
          {{ contacto.correo_electronico }}
        </b-card-text>
      </div>
    </b-col>
    <b-col v-if="contacto">
      <div class="mx-1 mb-0">
        <h5 class="text-capitalize mb-75">
          Telefono celular:
        </h5>
        <b-card-text>
          {{ contacto.telefono_celular }}
        </b-card-text>
      </div>
    </b-col>
    <b-col v-if="contacto">
      <div class="mx-1 mb-0">
        <h5 class="text-capitalize mb-75">
          Telefono local:
        </h5>
        <b-card-text>
          {{ contacto.telefono_local || 'SIN DATO' }}
        </b-card-text>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import {
  BAlert, BCol, BCardText, BRow,
} from 'bootstrap-vue'

export default {
  name: 'ContactoPrebecario',
  components: {
    BAlert,
    BCol,
    BCardText,
    BRow,
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    data: {
      type: [Object, Array],
      default: () => {},
    },
  },
  data() {
    return {
      contacto: null,
    }
  },
  mounted() {
    this.contacto = { ...this.data }
  },
  methods: {
    updateContacto(resp) {
      this.contacto = { ...resp }
    },
  },
}
</script>

<style></style>
